<template>
  <div class="home-container">
    <header
      class="header"
      v-if="isSaas"
    >
      <img
        src="@assets/logo-default.png"
        alt="OxpeckerLogo"
        class="logo"
      />
      <div class="links">
        <a
          class="home-link"
          href="/"
        >{{ $t('home') }}</a>
        <template v-if="isAuthenticated">
          <span class="separator" />
          <router-link
            class="blog-link"
            :to="{name: 'Blog'}"
            target="_blank"
          >{{$t('blog')}}</router-link>
        </template>
      </div>
    </header>
    <main class="main-content">
      <section class="text-content">
        <h1 class="main-title">
          {{ $t('mainTitle') }}
        </h1>
        <p class="description">
          {{ $t('description') }}
        </p>
        <router-link
          :to="to"
          class="get-started"
        >{{ $t('getStarted', { APP_TITLE: APP_TITLE }) }}</router-link>
        <div class="zero-text">
          <span class="zero-text-title">{{APP_TITLE}} {{$t('zeroTextTitle')}}</span>
          <ul>
            <li>
              <span class="zero-text-subtitle">{{$t('zeroDayVulnerability')}}</span>
            </li>
            <li>
              <span class="zero-text-subtitle">{{$t('zeroFalsePositive')}}</span>
            </li>
            <li>
              <span class="zero-text-subtitle">{{$t('zeroManualConfirmation')}}</span>
            </li>
          </ul>
        </div>
      </section>
      <section class="image-content">
        {{ logoAscii }}
      </section>
      <div class="makers">
        <div class="zero-text">
          <span class="zero-text-title">{{APP_TITLE}} {{$t('zeroTextTitle')}}</span>
          <ul>
            <li>
              <span class="zero-text-subtitle">{{$t('zeroDayVulnerability')}}</span>
            </li>
            <li>
              <span class="zero-text-subtitle">{{$t('zeroFalsePositive')}}</span>
            </li>
            <li>
              <span class="zero-text-subtitle">{{$t('zeroManualConfirmation')}}</span>
            </li>
          </ul>
        </div>
      </div>
      <footer class="footer">
        <p>{{ $t('footerText') }} <br />
          <a
            href="/document"
            style="font-weight: bold"
          >{{ $t('learnMore', { APP_TITLE: APP_TITLE }) }}</a> and <a
            target="_blank"
            href="https://x.com/zast_ai"
            style="font-weight: bold"
          >{{ $t('launchAnnouncement') }}</a>
        </p>
      </footer>
    </main>
  </div>
</template>

<script>
import { getTaskList } from '@/api/base';
import { mapGetters } from 'vuex';
const logoAscii = `
+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
++++++++++++++++++++++++++++++++++++++++++++++++++++++++##+++++++++++++++++++++++++++++++++++++++++++++++++++++++
++++++++++++++++++++++++++++++++++++++++++++++++++++#########++++++++++++++++++++++++++++++++++++++++++++++++++++
+++++++++++++++++++++++++++++++++++++++++++++++++###############+++++++++++++++++++++++++++++++++++++++++++++++++
++++++++++++++++++++++++++++++++++++++++++++++######################+++++++++++++++++++++++++++++++++++++++++++++
+++++++++++++++++++++++++++++++++++++++++++###########################+++++++++++++++++++++++++++++++++++++++++++
+++++++++++++++++++++++++++++++++++++++###################################+++++++++++++++++++++++++++++++++++++++
++++++++++++++++++++++++++++++++++++###################+++###################++++++++++++++++++++++++++++++++++++
+++++++++++++++++++++++++++++++++###################++++++++++##################+++++++++++++++++++++++++++++++++
++++++++++++++++++++++++++++++##################+++++++++++++++++###################+++++++++++++++++++++++++++++
+++++++++++++++++++++++++++##################++++++++++++++++++++++++#################+++++++++++++++++++++++++++
+++++++++++++++++++++++++++###############++++++++++++++++++++++++++++++##############+++++++++++++++++++++++++++
+++++++++++++++++++++++++++###########++++++++++++++++++++++++++++++++################+++++++++++++++++++++++++++
+++++++++++++++++++++++++++#########+++++++++++++++++++++++++++++++##################++++++++++++++++++++++++++++
+++++++++++++++++++++++++++#########+++++++++++++++++++++++++++###################+++++++++++++++++++++++++++++++
+++++++++++++++++++++++++++#########++++++++++++++++++++++++###################++++++++++++++++++++++++++++++++++
+++++++++++++++++++++++++++#########+++++++++++++++++++++##################++++++++++++++++++++++++++++++++++++++
+++++++++++++++++++++++++++#########++++++++++++++++++##################++++++++++####+++++++++++++++++++++++++++
+++++++++++++++++++++++++++#########++++++++++++++###################++++++++++#######+++++++++++++++++++++++++++
+++++++++++++++++++++++++++#########+++++++++++###################+++++++++++#########+++++++++++++++++++++++++++
+++++++++++++++++++++++++++#######++++++++++##################+++++++++++++++#########+++++++++++++++++++++++++++
+++++++++++++++++++++++++++###+++++++++++##################++++++++++++++++++#########+++++++++++++++++++++++++++
+++++++++++++++++++++++++++++++++++++###################+++++++++++++++++++++#########+++++++++++++++++++++++++++
++++++++++++++++++++++++++++++++++###################++++++++++++++++++++++++#########+++++++++++++++++++++++++++
+++++++++++++++++++++++++++++++##################++++++++++++++++++++++++++++#########+++++++++++++++++++++++++++
++++++++++++++++++++++++++++##################+++++++++++++++++++++++++++++++#########+++++++++++++++++++++++++++
+++++++++++++++++++++++++++################+++++++++++++++++++++++++++++++############+++++++++++++++++++++++++++
+++++++++++++++++++++++++++###############+++++++++++++++++++++++++++++###############+++++++++++++++++++++++++++
+++++++++++++++++++++++++++##################+++++++++++++++++++++++##################+++++++++++++++++++++++++++
++++++++++++++++++++++++++++++###################+++++++++++++++###################++++++++++++++++++++++++++++++
+++++++++++++++++++++++++++++++++###################+++++++++###################+++++++++++++++++++++++++++++++++
+++++++++++++++++++++++++++++++++++++##################+++###################++++++++++++++++++++++++++++++++++++
++++++++++++++++++++++++++++++++++++++++#################################++++++++++++++++++++++++++++++++++++++++
+++++++++++++++++++++++++++++++++++++++++++############################++++++++++++++++++++++++++++++++++++++++++
++++++++++++++++++++++++++++++++++++++++++++++#####################++++++++++++++++++++++++++++++++++++++++++++++
++++++++++++++++++++++++++++++++++++++++++++++++++##############+++++++++++++++++++++++++++++++++++++++++++++++++
+++++++++++++++++++++++++++++++++++++++++++++++++++++########++++++++++++++++++++++++++++++++++++++++++++++++++++
++++++++++++++++++++++++++++++++++++++++++++++++++++++++#++++++++++++++++++++++++++++++++++++++++++++++++++++++++
+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++`;

export default {
  name: 'HomePage',
  data() {
    return {
      blogUrl: '',
      to: { name: 'MainView' },
      logoAscii: '+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++',
    };
  },
  created() {
    if (this.hasAccess) {
      this.getTaskList();
    }
  },
  mounted() {
    const that = this;
    const r = 1500;
    const m = performance.now();
    function u(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }
    function o(t) {
      const a = t - m,
        i = Math.min(a / r, 1),
        s = u(i),
        e = Math.floor(s * logoAscii.length);
      (that.logoAscii = logoAscii.slice(0, e)), e < logoAscii.length && requestAnimationFrame(o);
    }

    requestAnimationFrame(o);
  },
  computed: {
    ...mapGetters('user', ['hasAccess', 'isAuthenticated']),
    ...mapGetters('common', ['isSaas']),
  },
  methods: {
    getTaskList() {
      getTaskList({ page: 0, size: 1, filters: [] }).then((res) => {
        if (res?.total && res.total > 0) {
          this.to = { name: 'LoopholeScan' };
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@media screen and (max-width: 1920px) {
  .image-content {
    font-size: 13px !important;
  }
}

@media screen and (max-width: 1440px) {
  .image-content {
    font-size: 10px !important;
  }

  .main-title {
    font-size: 30px !important;
  }
}

@media screen and (max-width: 1024px) {
  .image-content {
    font-size: 7px !important;
  }

  .main-title {
    font-size: 20px !important;
  }

  .description {
    font-size: 14px !important;
  }

  .get-started {
    font-size: 14px !important;
  }

  .zero-text-title {
    font-size: 14px !important;
  }

  .footer {
    font-size: 14px !important;
  }

  .zero-text-subtitle {
    font-size: 12px !important;
  }
}

@media screen and (max-width: 768px) {
  .logo {
    width: 140px !important;
  }

  .image-content {
    font-size: 5px !important;
    justify-self: center;
  }

  .zero-text {
    display: none;
    padding: 0 !important;
  }

  .makers {
    padding: 0px 20px;
    .zero-text {
      display: block !important;
    }

    ul {
      margin: 0 !important;
    }
  }

  .footer {
    padding: 0px 20px;

    p {
      margin: 0 !important;
    }
  }

  .main-content {
    grid-template-columns: 1fr !important;
  }

  .get-started {
    margin-bottom: 0 !important;
  }
}

.blog-link {
  font-size: 20px;
  color: #000;
  text-decoration: underline;
  font-style: italic;
}

.links {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
}

.zero-text {
  margin-top: auto;
}

.zero-text-title {
  font-size: 18px;
  font-weight: bold;
  color: #000;
}

.separator {
  display: inline-block;
  margin: 0px 10px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #000;
}

.image-content {
  margin-top: -0.5em;
  white-space: pre;
  font-family: monospace;
  font-size: 13px;
  line-height: 1;
  letter-spacing: unset;
  transform: unset;
  overflow: hidden;
  aspect-ratio: 668 / 400;
  height: fit-content;
  width: fit-content;
}

.home-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  padding: 20px;

  .header {
    width: 98%;
    max-width: 1920px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background-color: #fff;
    border-radius: 5px;

    .logo {
      width: 175px;
    }

    .home-link {
      font-size: 20px;
      color: #000;
      text-decoration: underline;
      font-style: italic;
    }
  }

  .main-content {
    display: grid;
    grid-template-columns: minmax(auto, 1fr) auto;
    width: 100%;
    row-gap: 20px;
    max-width: 1920px;

    .text-content {
      display: flex;
      flex-direction: column;
      flex: 1;
      padding: 0px 20px;

      .cognition {
        font-size: 20px;
        font-weight: bold;
        color: #000000;
      }

      .main-title {
        margin-top: 40px;
        font-size: 40px;
        font-weight: bold;
        color: #000;
        line-height: 1.2;
        margin: 0px;
      }

      .description {
        font-size: 18px;
        color: #000000;
        line-height: 1.5;
        margin-bottom: 20px;
      }

      .get-started {
        font-size: 20px;
        color: #28a745;
        text-decoration: none;
        font-weight: bold;
        margin-bottom: 20px;
        display: inline-block;
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .makers {
      font-size: 16px;
      color: #555;

      .zero-text {
        display: none;
        padding: 16px 0;
      }
    }
  }

  .footer {
    text-align: left;
    font-size: 16px;
    color: #555;

    p {
      color: #000;
    }

    a {
      color: #000;
      text-decoration: underline;
    }
  }
}
</style>
